<script>
import appConfig from "@/app.config";
import { mapActions } from 'vuex';

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    $route(to) {
      if (!to.params.keepNotifications) this.clear(); // clear alert on location change
    },
  },
  methods: {
    ...mapActions('notification', ['clear']),
  },
};
</script>

<template>
  <div id="app">
    <RouterView />
  </div>
</template>
